<template>
    <div class="lo heading">
        <mdCaption
            :caption="caption"
        >
            <cpLabel
                v-if="minorCaption"
                themes="minor"
                :text="minorCaption"
            ></cpLabel>
        </mdCaption>
        <slot></slot>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import cpLabel from '@/components/cpLabel'

    export default {
        components: {
            mdCaption,
            cpLabel,
        },
        props: {
            caption: {
                type: String,
                required: false,
                default: ''
            },
            minorCaption: {
                type: String,
                required: false,
                default: ''
            },
        },
    }
</script>

<style scoped lang="scss">

    .lo.heading {
        $lh: 1px;

        display: flex;
        flex-shrink: 0;
        position: relative;
        padding-top: $interval-s;
        // padding-bottom: $interval-m;
        // border-bottom: $lh solid transparent;
        margin-bottom: $interval-m;

        // &::before, &::after {
        //     content: $content;
        //     left: 0;
        //     position: absolute;
        // }

        // &::before {
        //     bottom: 0;
        //     right: 0;
        //     height: $lh;
        //     background-color: $major-color;
        // }

        // &::after {
        //     bottom: -2px;
        //     height: 5px;
        //     width: 20px;
        //     border-radius: 2px;
        //     background-color: $major-color;
        // }
    }
</style>
